import { render, staticRenderFns } from "./routedetails.vue?vue&type=template&id=0c6e9fed&scoped=true&"
import script from "./routedetails.vue?vue&type=script&lang=js&"
export * from "./routedetails.vue?vue&type=script&lang=js&"
import style0 from "./routedetails.vue?vue&type=style&index=0&id=0c6e9fed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6e9fed",
  null
  
)

export default component.exports